import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e16a0822")

_pushScopeId("data-v-e16a0822")
const _hoisted_1 = { class: "code_container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.codeLength, (position, index) => {
      return (_openBlock(), _createBlock("input", {
        ref: 'input_' + index,
        type: "number",
        class: "fev_text1 fw_700",
        maxlength: "1",
        value: _ctx.completeCode[index],
        tabindex: _ctx.tabIndex,
        placeholder: "-",
        onPaste: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pasted && _ctx.pasted(...args))),
        key: position + index,
        onInput: ($event: any) => (_ctx.inserted($event, index)),
        readonly: _ctx.readonly,
        min: _ctx.min,
        max: _ctx.max,
        step: _ctx.step
      }, null, 40, ["value", "tabindex", "onInput", "readonly", "min", "max", "step"]))
    }), 128))
  ]))
})